import {
  STATUS_ERROR,
  STATUS_INITIAL,
  STATUS_NOT_FOUND,
  STATUS_PENDING,
  STATUS_SUCCESS,
} from '~/constants';

import { ActionType, ExperienceState } from './model';

export const initialState: ExperienceState = {
  shortId: null,
  experience: null,
  lang: 'en',
  status: STATUS_INITIAL,
  isInactive: false,
  redirectUrl: null,
};

function logger(type, value = '') {
  console.info(
    `%cDispatcher: ${type} ${value ? `- ${value}` : ''}`,
    'color: #bada55;',
  );
}

function reducer(state: ExperienceState, action: ActionType): ExperienceState {
  switch (action.type) {
    case 'FETCH_EXPERIENCE':
      logger(action.type, 'PENDING');
      return {
        ...state,
        ...initialState,
        status: STATUS_PENDING,
      };
    case 'FETCH_EXPERIENCE_SUCCESS':
      logger(action.type, action.payload.experience.id);
      return {
        ...state,
        ...action.payload,
        status: STATUS_SUCCESS,
      };
    case 'EXPERIENCE_REDIRECT_URL':
      logger(action.type, action.payload.redirectUrl);
      return {
        ...state,
        ...action.payload,
        experience: null,
        status: STATUS_ERROR,
      };
    case 'FETCH_EXPERIENCE_ERROR':
      logger(action.type, action.payload.shortId);
      return {
        ...state,
        ...action.payload,
        experience: null,
        status: STATUS_ERROR,
      };
    case 'EXPERIENCE_NOT_FOUND':
      logger(action.type, action.payload.shortId);
      return {
        ...state,
        ...action.payload,
        experience: null,
        status: STATUS_NOT_FOUND,
      };
  }
}

export default reducer;
